export default {
  email: 'ईमेल',
  physicalAddress: 'भौतिक पता',
  webSiteUrl: 'वेबसाइट यूआरएल',
  loadingApplication: 'लोडिंग आवेदन',
  baseUrl: 'बेस यूआरएल',
  redirectionUrl: 'रीडायरेक्शन यूआरएल',
  prefix: 'उपसर्ग',
  pickAApplicationColor: 'अपने आवेदन के लिए एक रंग का चयन करें',
  applicationSuccessfullyUpdated: 'आवेदन सफलतापूर्वक अद्यतन किया गया था',
  apiKeyCopied: 'एपीआई कुंजी की नकल की',
  apiKeyCopyError: 'एपीआई कुंजी की नकल करने में त्रुटि',
  changingPublicKeyWillAffectApps: 'सार्वजनिक कुंजी बदलने से उपयोग में आने वाले सभी अनुप्रयोग प्रभावित होंगे। क्या आप जारी रखना चाहते हैं?',
  apiKey: 'एपीआई कीज',
  goToApiDoc: 'एपीआई डॉक्टर के पास जाएं',
  publicKey: 'सार्वजनिक कुंजी',
  privateKey: 'निजी कुंजी',
  generate: 'उत्पन्न',
  reNewPublicKey: 'सार्वजनिक कुंजी का नवीनीकरण करें',
  deleteInfoField: 'सूचना फ़ील्ड हटाएं',
  sureToDeleteInfoField: 'क्या आप सुनिश्चित हैं कि आप इस जानकारी फ़ील्ड को हटाना चाहते हैं?',
  addInfoOfPeopleOfBrand: 'आपके ब्रांड के लोगों के बारे में अतिरिक्त जानकारी',
  sectionAddInfoPeopleOfBrandRequested: 'इस अनुभाग में आप अतिरिक्त जानकारी जोड़ सकते हैं जो आपके ब्रांड के लोगों से अनुरोध की जाएगी',
  onlyBeSeenByAppAdministrator: 'केवल आवेदन प्रशासक द्वारा देखा जा सकता है',
  canBeSeenByPeople: 'देखा जा सकता है और उनके प्रोफ़ाइल से लोगों द्वारा संशोधित',
  shortTextField: 'लघु पाठ क्षेत्र',
  dropDownList: 'ड्रॉप-डाउन सूची',
  addNewInfoField: 'नई जानकारी फ़ील्ड जोड़ें',
  enterExtraDataId: 'एक्स्ट्राडाटा पहचानकर्ता दर्ज करें',
  epayCoCredentials: 'एपिको क्रेडेंशियल्स',
  emailVerifyCredentials: 'ईमेल सूची सत्यापित साख',
  testEnvironment: 'टेस्ट पर्यावरण',
  update: 'अद्यतन',
  modifyAddInfoField: 'अतिरिक्त जानकारी फ़ील्ड को संशोधित करें',
  createAddInfoField: 'अतिरिक्त जानकारी फ़ील्ड बनाएं',
  fieldSuccessfullyDeleted: 'फ़ील्ड को सफलतापूर्वक हटा दिया गया था',
  fieldName: 'फ़ील्ड का नाम',
  access: 'पहुँच',
  addOptions: 'विकल्प जोड़ें',
  option: 'विकल्प | विकल्प',
  fieldSuccessfullyCreated: 'फ़ील्ड सफलतापूर्वक बनाया गया था',
  fieldSuccessfullyUpdated: 'फ़ील्ड को सफलतापूर्वक अपडेट किया गया',
  application: 'अनुप्रयोग | अनुप्रयोगों',
  addAdministrator: 'प्रशासक जोड़ें',
  administratorsPerPage: 'प्रति पृष्ठ प्रशासक',
  yes: 'हाँ',
  no: 'नहीं',
  loadingAdministrators: 'लोडिंग प्रशासक',
  noAdministratorsRegistered: 'कोई पंजीकृत प्रशासक नहीं',
  action: 'कार्रवाई कार्यों',
  publicKeyUpdated: 'पब्लिक कुंजी को अपडेट किया गया',
  editAdministrator: 'प्रशासक को संपादित करें',
  newAdministrator: 'नए प्रशासक',
  selectAdministratorType: 'प्रशासक प्रकार का चयन करें',
  wantAdministratorInactive: 'क्या आप चाहते हैं कि प्रशासक निष्क्रिय हो?',
  selectAdministratorPermissions: 'प्रशासक की अनुमतियों का चयन करें',
  addNewAdministrator: 'नए प्रशासक जोड़ें',
  administratorSuccessfullyCreated: 'प्रशासक सफलतापूर्वक बनाया',
  administratorSuccessfullyUpdate: 'प्रशासक सफलतापूर्वक अद्यतन',
  wantToDeleteAdministrator: 'क्या आप इस प्रशासक को हटाना चाहते हैं?',
  deleteAdministrator: 'प्रशासक हटाएं',
  administratorSuccessfullyDeleted: 'प्रशासक सफलतापूर्वक हटा दिया',
  successfullyColorUpdated: 'रंग सफलतापूर्वक अद्यतन',
  creditCard: 'क्रेडिट कार्ड',
  inviteFinancier: 'फाइनेंसर को आमंत्रित करें | फाइनेंसर को आमंत्रित करें',
  billing: 'बिलिंग',
  addCreditCard: 'क्रेडिट कार्ड जोड़ें',
  loadBalance: 'लोड बैलेंस',
  usage: 'उपयोग | उपयोग | उपयोग',
  payment: 'भुगतान |भुगतान |भुगतान | भुगतान',
  paymentMethods: 'भुगतान के तरीके',
  completeBusinessDataBeforeAddingCreditCard: 'क्रेडिट कार्ड जोड़ने से पहले अपने व्यवसाय विवरण को पूरा करें',
  lastDigits: 'अंतिम अंक',
  cardExpirationDate: 'समाप्ति की तारीख',
  changeToPrincipal: 'प्रिंसिपल में बदलाव',
  creditCardSuccessfullyDeleted: 'क्रेडिट कार्ड सफलतापूर्वक हटाया गया',
  errorDeletingCreditCard: 'आपके कार्ड को हटाने में हुई कोई त्रुटि',
  creditCardPriorityUpdated: 'क्रेडिट कार्ड प्राथमिकता अद्यतन',
  dailyUsage: 'दैनिक उपयोग',
  report: 'रिपोर्ट',
  recordsPerPage: 'प्रति पृष्ठ रिकॉर्ड',
  loadingRecords: 'रिकॉर्ड लोड करना',
  noMovementsRecords: 'कोई आंदोलन रिकॉर्ड नहीं हैं',
  service: 'सेवा',
  amount: 'राशि',
  value: 'मान',
  successfullyMovementsReportDownloaded: 'आंदोलन रिपोर्ट सफलतापूर्वक डाउनलोड किया गया था',
  detailedConsumption: 'विस्तृत खपत',
  approved: 'अनुमोदित | अनुमोदित',
  creditCardRechargeWithOutCharge: 'बिना शुल्क क्रेडिट कार्ड रिचार्ज करें',
  methodOf: 'की विधि',
  billCollection: 'बिल संग्रह',
  NoAdditionalInfoOfPayment: 'अतिरिक्त भुगतान की जानकारी के बिना',
  noPaymentsRecords: 'कोई भुगतान रिकॉर्ड नहीं',
  invoice: 'इनवॉइस',
  deposit: 'जमा',
  makePayment: 'भुगतान करें',
  warning: 'चेतावनी',
  rechargeToAvoidBlockingMainFunctions: 'आपको अपने मुख्य कार्यों को अवरुद्ध करने से बचने के लिए अपने खाते को रिचार्ज करना चाहिए',
  load: 'भार',
  enterIdCardNumber: 'अपना आईडी नंबर डालें',
  idCardNumber: 'आईडी नंबर',
  createCard: 'कार्ड बनाएं',
  youMustCompleteCardInformation: 'आपको अपने क्रेडिट कार्ड के विवरण को पूरा करना होगा',
  cardInformationIncorrect: 'कार्ड विवरण गलत हैं',
  creditCardSuccessfullyAdded: 'क्रेडिट कार्ड सफलतापूर्वक जोड़ा गया',
  checkCardDetails: 'कार्ड विवरण की जांच करें',
  rejectedCard: 'कार्ड खारिज कर दिया गया था',
  errorAddingCardPleaseTryAgain: 'कार्ड जोड़ने में त्रुटि। कृपया फिर से प्रयास करें',
  noDependencies: 'कोई निर्भरता नहीं',
  dependsOn: 'पर निर्भर करता है',
  loadingJourneys: 'लोडिंग यात्राएं',
  noJourneysForThisApp: 'इस आवेदन के लिए कोई यात्रा नहीं',
  editJourney: 'यात्रा संपादित करें',
  addNewJourney: 'नई यात्रा जोड़ें',
  dependencies: 'निर्भरताएँ',
  selectJourneyColor: 'यात्रा के रंग का चयन करें',
  chooseAColor: 'रंग चुनें',
  wantThisDefaultStateWhenSomeoneSignsUp: 'क्या आप चाहते हैं कि जब कोई साइन अप करे तो यह डिफ़ॉल्ट स्थिति हो?',
  wantToShowThisStateOnTheSideMenu: 'क्या आप इस स्थिति को साइड मेनू में प्रदर्शित करना चाहते हैं?',
  loadingJourney: 'लोडिंग यात्रा',
  addJourney: 'यात्रा जोड़ें',
  journeySuccessfullyCreated: 'यात्रा सफलतापूर्वक बनाई गई',
  journeySuccessfullyEdited: 'यात्रा सफलतापूर्वक संपादित',
  yellow: 'पीला',
  orange: 'नारंगी',
  red: 'नेटवर्क',
  purple: 'बैंगनी',
  darkBlue: 'डार्क ब्लू',
  lightBlue: 'लाइट ब्लू',
  green: 'हरा',
  wantToDeleteJourney: 'क्या आप इस यात्रा को हटाना चाहते हैं?',
  deleteJourney: 'यात्रा हटाएं',
  journeySuccessfullyDeleted: 'यात्रा सफलतापूर्वक हटाई गई',
  clickToSearchOnTheComputer: '... या अपने कंप्यूटर पर फ़ाइलों को खोजने के लिए यहां क्लिक करें',
  lastName: 'अंतिम नाम',
  logInWith: 'साथ लॉगिन करें',
  signInWith: 'साइन इन के साथ',
  logInToYourAccount: 'अपने खाते में लॉगइन करें',
  signIn: 'साइन इन करें',
  selectColor: 'रंग का चयन करें',
  selectLogo: 'लोगो का चयन करें',
  customPhrase: 'कस्टम वाक्यांश',
  customPhraseOnLogIn: 'लॉगिन पर कस्टम वाक्यांश',
  customPhraseOnSignIn: 'साइन इन पर कस्टम वाक्यांश',
  enterSignInMode: 'साइन इन मोड दर्ज करें',
  customPhraseOnLogInButton: 'लॉगिन बटन पर कस्टम वाक्यांश',
  customPhraseOnSignInButton: 'बटन में साइन पर कस्टम वाक्यांश',
  hideSocialNetworks: 'सामाजिक नेटवर्क को छिपाना',
  showSignInFirst: 'पहले में साइन दिखाएं',
  showCustomButton: 'कस्टम बटन दिखाएं',
  buttonText: 'बटन टेक्स्ट',
  requestData: 'डेटा का अनुरोध करें',
  defaultData: 'डिफ़ॉल्ट डेटा',
  identification: 'पहचान',
  department: 'विभाग',
  healthProvider: 'स्वास्थ्य प्रदाता',
  bloodType: 'रक्त प्रकार',
  day: 'दिन | दिनों',
  month: 'महीना | महीने',
  allTheData: 'सभी डेटा',
  year: 'साल | साल',
  range: 'श्रेणी',
  insertTheHtmlTemplateInTheFollowingField: 'निम्नलिखित फ़ील्ड में एचटीएमएल टेम्पलेट डालें',
  templatePreview: 'टेम्पलेट पूर्वावलोकन',
  propfilePicUpdates: 'प्रोफ़ाइल चित्र अपडेट किया गया',
  /* Forms */
  solo: 'केवल',
  normal: 'सामान्य',
  needToRefreshBeforeCreateForms: 'फॉर्म बनाने से पहले आपको रिफ्रेश करना होगा',
  createForm: 'फॉर्म बनाएं',
  formsPerPage: 'प्रति पेज फॉर्म',
  loadingForms: 'लोडिंग फॉर्म',
  noFormsRegistered: 'कोई पंजीकृत फॉर्म नहीं हैं',
  formName: 'फॉर्म का नाम',
  insertFormOnWebSite: 'अपनी वेबसाइट पर फॉर्म डालें',
  personalization: 'वैयक्तिकरण',
  injectableCode: 'इंजेक्टेबल कोड',
  customYourFormAndInsertGeneratedCodeOnTheNextTab: 'अपने फॉर्म को कस्टम करें और फिर निम्नलिखित टैब पर जेनरेट किए गए कोड डालें',
  style: 'शैली',
  responseMessageSent: 'जवाब संदेश भेजा',
  sendButton: 'बटन भेजें',
  length: 'लंबाई',
  alignment: 'संरेखण',
  selectFormColor: 'अपने फॉर्म का रंग चुनें',
  divWithKeybeFormsToInsertForm: 'अपने वेब पेज पर एक फॉर्म डालने के लिए. आपको अपनी साइट के शरीर में आईडी ',
  andThenAddTheNextScriptToTheFooter: 'फिर अपनी साइट के फुटर में निम्नलिखित स्क्रिप्ट जोड़ें',
  left: 'बाएँ',
  right: 'सही',
  center: 'केंद्र',
  small: 'छोटे',
  large: 'बड़े',
  none: 'कोई नहीं',
  outlined: 'उल्लिखित',
  filled: 'भरा',
  editForm: 'फॉर्म संपादित करें',
  registerForm: 'रजिस्टर फॉर्म',
  obligateLogIn: 'क्या आप लॉगिन को मजबूर करते हैं?',
  assignRoleWhenFormIsCompleted: 'फॉर्म पूरा होने पर भूमिका असाइन करें?',
  setUpNotificationsEmailForm: 'एक ईमेल सेट करें जहां आपको फॉर्म सबमिशन की सूचनाएं मिलेंगी',
  emailSubject: 'ईमेल विषय',
  sendEmailOnSubmit: 'सबमिट प्राप्त करते समय ईमेल भेजें',
  sendSmsOnSubmit: 'सबमिट प्राप्त करते समय एसएमएस भेजें',
  fields: 'फ़ील्ड',
  addField: 'फ़ील्ड जोड़ें',
  needToSelectRegisterEmailOrPhone: 'आपको पंजीकरण ईमेल या फोन का चयन करना होगा',
  formSuccessfullyEdited: 'फॉर्म सफलतापूर्वक संपादित किया गया था',
  fieldLength: 'फ़ील्ड लंबाई',
  required: 'आवश्यक',
  minFiles: 'फाइलों की न्यूनतम संख्या',
  linkOfTermsAndConditions: 'नियम और शर्तों से लिंक करें',
  dataHandlingLink: 'डेटा हैंडलिंग लिंक',
  verificationFields: 'सत्यापन फ़ील्ड',
  filesUpLoad: 'फ़ाइलें अपलोड करें',
  dataManagement: 'डेटा प्रबंधन',
  hide: 'छुपाना',
  multipleOption: 'एकाधिक विकल्प',
  NoRestrictions: 'कोई प्रतिबंध नहीं',
  fullRow: 'पूरी पंक्ति',
  halfRow: 'आधी पंक्ति',
  newForm: 'नया रूप',
  addNewForm: 'नया रूप जोड़ें',
  formSuccessfullyCreated: 'फॉर्म सही ढंग से बनाया गया',
  files: 'फ़ाइलें',
  fileType: 'फाइल प्रकार',
  responses: 'प्रतिक्रिया',
  responsesPerPage: 'प्रति पृष्ठ प्रतिक्रियाएं',
  loadingResponses: 'प्रतिक्रियाएं लोड करना',
  noResponsesYet: 'आपको अभी तक उत्तर नहीं मिला है',
  next: 'अगला',
  largeTextField: 'बड़े टेक्स्ट फील्ड',
  registry: 'रजिस्ट्री',
  creatingANewApplicationIsVerySimpleJustFillInTheInformationWeRequestToGoToTheNextStep: 'एक नया आवेदन बनाना बहुत सरल है. बस उस जानकारी को भरें जो हम अगले चरण में जाने का अनुरोध करते हैं (सामाजिक नेटवर्क सेट करें)',
  applicationName: 'आवेदन का नाम',
  addNewApplication: 'नया आवेदन बनाएं',
  applicationSuccessfullyCreated: 'आवेदन सफलतापूर्वक बनाया गया था',
  saveNewBusiness: 'नए व्यवसाय को बचाएं',
  thePageYouAreLookingForDoesNotExist: 'आप जिस पृष्ठ की तलाश कर रहे हैं वह मौजूद नहीं है',
  darkTheme: 'डार्क थीम',
  lightTheme: 'प्रकाश विषय',
  sidebar: 'साइडबार',
  toolbar: 'टूलबार',
  money: 'पैसे',
  showFieldInPeopleFilters: 'लोगों के फ़िल्टर में फ़ील्ड दिखाएं',
  timeZoneInformation: `
  अपने समय क्षेत्र को निर्दिष्ट करना आवश्यक है ताकि आपके द्वारा सौंपे गए कार्यों
  और डेटा के निर्माण और अद्यतन की तिथियां सही ढंग से प्रदर्शित हों।
  `
}
